export default {
  getSharedEnv: function getSharedEnv(_ref) {
    var payload = _ref.payload;
    return payload;
  },
  tracking: function tracking(_ref2) {
    var payload = _ref2.payload;
    return payload.tracking;
  },
  oauth: function oauth(_ref3) {
    var payload = _ref3.payload;
    return payload.oauth;
  }
};